//TODO: Move constants from server folder to here so that we can use the same constants across both server and client directory

export const CONSUMER = 'consumer'
export const MERCHANT = 'merchant'
// min characters required for search
export const MIN_LENGTH_SEARCH_CHAR = 2
// max characters required for search
export const MAX_LENGTH_SEARCH_CHAR = 60
export const PERSONAL = 'personal'
export const BUSINESS = 'business'
export const TECHNICAL = 'technical'

export const JP = 'JP'

export const PAYPAL_OBJECTS_BASE_URL = 'https://www.paypalobjects.com'

export const YT_IFRAME_SCRIPT_URL = 'https://www.youtube.com/iframe_api'

export const pageNames = {
  HOME: 'home',
  ARTICLE: 'article',
  TOPIC: 'topic',
  HELP_GUIDES: 'helpGuides',
  SEARCH: 'search',
  PERSONAL: 'personal',
  BUSINESS: 'business',
  TECHNICAL: 'technical',
}
